import { Shield, UserCheck, Users, CreditCard } from 'lucide-react'

export const callTypes = new Map<string, string>([
  ['active', 'bg-teal-soft/30 text-teal border-teal-border'],
  ['inactive', 'bg-border/40 border-border'],
  ['invited', 'bg-info-soft/40 text-info border-info-border'],
  [
    'suspended',
    'bg-destructive/10 dark:bg-destructive/50 text-destructive dark:text-primary border-destructive/10',
  ],
])

export const roles = [
  {
    label: 'Superadmin',
    value: 'superadmin',
    icon: Shield,
  },
  {
    label: 'Admin',
    value: 'admin',
    icon: UserCheck,
  },
  {
    label: 'Manager',
    value: 'manager',
    icon: Users,
  },
  {
    label: 'Cashier',
    value: 'cashier',
    icon: CreditCard,
  },
] as const
